// utils/stripe.js or inside your component
import { loadStripe } from '@stripe/stripe-js';

// Optional: Load with publishable key now or later
const key = process.env.REACT_APP_STRIPE_KEY;
if (!key) {
  console.error('Stripe key is missing. Please set STRIPE_KEY in your environment variables.');
}
const stripePromise = loadStripe(key);

export const createCheckoutSession = async (email, tier_name, credits = 10) => {
  try {
    const response = await fetch('http://127.0.0.1:8000/api/payments/create-checkout-session/', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        // If using JWT or session-based auth, include credentials
        'Authorization': `Bearer eccdbaf38aa9ece8c34fbbc9f06803e2208ad7f2`,
      },
      body: JSON.stringify({ email, tier_name, credits }),
    });

    const data = await response.json();
    if (data.url) {
      window.location.href = data.url; // Stripe hosted payment page
    } else {
      console.error('Session creation failed:', data);
    }
  } catch (err) {
    console.error('Error initiating checkout:', err);
  }
}